// ========================
// REFRESH SIDE CART
// ========================
function refreshSideCart_cartjs() {
  fetch("/cart?section_id=cart-drawer")
  .then(res => res.text())
  .then(html => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const newDrawer = doc.querySelector("cart-drawer");
    if (!newDrawer) return;

    const totalQty = parseInt(newDrawer?.getAttribute("data-totalqty") || "0", 10);
    updateCartBubble(totalQty);

    const existingDrawer = document.querySelector("cart-drawer");
    if (!existingDrawer) return;

    const innerNew = newDrawer.querySelector('.drawer__inner');
    const innerCurrent = existingDrawer.querySelector('.drawer__inner');
    if (innerNew && innerCurrent) {
      innerCurrent.innerHTML = innerNew.innerHTML;
    }

    existingDrawer.classList.toggle("is-empty", totalQty === 0);
    existingDrawer.classList.add("active");

    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    if (window.StackDiscounts) {
      setTimeout(function() {
        window.StackDiscounts.initStackDiscounts();
        window.StackDiscounts.initProductBundles();
        window.StackDiscounts.initProductLabels();
      }, 400);
    }
  });
}

// ========================
// CART OPERATION QUEUE
// cartOpStart and cartOpEnd are defined in cart.js with pendingCartOps counter.
// These stubs ensure no reference errors if custom.js executes first.
// ========================
if (typeof cartOpStart === 'undefined') {
  var cartOpStart = function() {};
}
if (typeof cartOpEnd === 'undefined') {
  var cartOpEnd = function() {};
}


// ========================
// MASTER CART UPDATE
// Call this after any add/remove. Handles gifts, shipping protection, then refreshes once.
// ========================
async function updateCartAndRefresh() {
  try {
    cartOpStart();
    const res = await fetch('/cart.js');
    const parsedState = await res.json();

    // Fix gifts
    await fixGifts(parsedState);

    // Fix shipping protection
    await fixShippingProtection_customjs(parsedState);

    // Refresh once at the end
    await refreshSideCart_cartjs();
  } catch(e) {
    console.error("Cart update error:", e);
  } finally {
    cartOpEnd();
  }
}

// ========================
// INITIALIZE CART SLIDER
// ========================
function initializeCartSlider() {
  const drawer = document.querySelector(".drawer__inner-complete-items");
  const swiperContainer = drawer?.querySelector(".cart-items.swiper");
  if (swiperContainer) {
    if (swiperContainer.classList.contains("swiper-initialized")) {
      swiperContainer.swiper.destroy(true, true);
    }
    new Swiper('.cart-items.swiper', {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.swiper-scrollbar',
      },
      loop: false,
    });
  }
}

// ========================
// CART BUBBLE
// ========================
function updateCartBubble(totalQty) {
  const cartIcon = document.querySelector("#cart-icon-bubble");
  if (!cartIcon) return;

  const existingBubble = cartIcon.querySelector(".cart-count-bubble");
  if (existingBubble) existingBubble.remove();

  if (totalQty > 0) {
    cartIcon.insertAdjacentHTML("beforeend", `
      <div class="cart-count-bubble">
        <span aria-hidden="true">${totalQty}</span>
        <span class="visually-hidden">${totalQty} item${totalQty > 1 ? "s" : ""}</span>
      </div>
    `);
  }
}

// ========================
// GIFT PRODUCT ADD BTN (tier-based free gift)
// ========================
document.addEventListener("click", function (e) {
  const btn = e.target.closest(".gift-product-add-btn");
  if (!btn) return;

  const cell = e.target.closest(".gift-product-cell");
  const select = cell
    ? cell.querySelector("#GiftProductSelect")
    : document.querySelector("#GiftProductSelect");
  const variantId = select ? select.value : btn.dataset.variantId;
  if (!variantId) return;

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", "Accept": "application/json" },
    body: JSON.stringify({ id: variantId, quantity: 1 }),
  })
    .then(res => res.json())
    .then(() => updateCartAndRefresh())
    .catch(err => console.error("Error adding gift product:", err));
});

document.addEventListener("change", function (e) {
  const select = e.target.closest("#GiftProductSelect");
  if (!select) return;

  const cell = select.closest(".gift-product-cell");
  const btn = cell
    ? cell.querySelector(".gift-product-add-btn")
    : document.querySelector(".gift-product-add-btn");

  const imgUrl = select.selectedOptions?.[0]?.dataset?.imgurl || select.dataset.imgurl;
  if (imgUrl && imgUrl.trim() !== "") {
    const imgTarget = select.closest(".gift-product-item")?.querySelector(".gift-product-image img");
    if (imgTarget) imgTarget.src = imgUrl;
  }

  if (btn) btn.dataset.variantId = select.value;
});

// ========================
// BUNDLE ADD TO CART
// ========================
document.addEventListener("click", function (e) {
  const cartBtn = e.target.closest(".cart_button");
  if (!cartBtn) return;

  const mainContainer = cartBtn.closest('.bundle-summary');
  const spinner = cartBtn.querySelector('.loading__spinner');
  if (!mainContainer) return;

  const emptyContainers = mainContainer.querySelectorAll('.empty');
  if (emptyContainers.length > 0) {
    document.querySelector('.notify-wrapper')?.classList.add('error');
    return;
  }

  const productInfo = [];
  mainContainer.querySelectorAll('.bundle-item').forEach(productDetail => {
    const pro_info = productDetail.querySelector('.item-info');
    if (!pro_info) return;
    const pro_name = pro_info.querySelector('.item-title')?.textContent.trim() || '';
    const pro_size = pro_info.querySelector('.item-size')?.textContent.replace('Size:', '').trim() || '';
    productInfo.push(`${pro_name} - Size ${pro_size}`);
  });

  document.querySelector('.notify-wrapper')?.classList.remove('error');

  const bundleId = Number(cartBtn.dataset.bundleId);
  if (!bundleId) { console.error('Invalid variant ID'); return; }

  const bundlePriceContainer = cartBtn.closest('.bundle-footer');
  const priceElement = bundlePriceContainer?.querySelector('.new-price');
  // priceElement used for display only, not needed for add

  if (spinner) spinner.classList.remove('hidden');
  cartBtn.classList.add('custom-disable');

  const lineItemProperties = productInfo.reduce((acc, item, index) => {
    acc[`item-${index + 1}`] = item;
    return acc;
  }, {});

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", "Accept": "application/json" },
    body: JSON.stringify({ id: bundleId, quantity: 1, properties: { ...lineItemProperties } }),
  })
    .then(res => res.json())
    .then(() => updateCartAndRefresh())
    .catch(err => console.error("Error adding bundle product:", err))
    .finally(() => {
      if (spinner) spinner.classList.add('hidden');
      cartBtn.classList.remove('custom-disable');
    });
});

// ========================
// SHIPPING PROTECTION TOGGLE
// ========================
document.addEventListener('change', function (e) {
  const toggle = e.target.closest('#shippingProtectionToggle');
  if (!toggle) return;

  if (toggle.checked) {
    updateCartAndRefresh();
  } else {
    removeShippingProtection_customjs();
  }
});

// ========================
// GET CART AND FIX SHIPPING (kept for compatibility)
// ========================
async function getCartAndFixShippingProtection() {
  await updateCartAndRefresh();
}

// ========================
// FIX SHIPPING PROTECTION
// ========================
function getShippingProtectionData(cartTotal) {
  if (!window.shippingProtectionLevels) return null;
  for (const level of window.shippingProtectionLevels) {
    if (cartTotal <= level.max) return level;
  }
  return null;
}

async function fixShippingProtection_customjs(parsedState) {
  const cartTotal = (parsedState.total_price / 100).toFixed(2);
  const return_level_var = getShippingProtectionData(cartTotal);
  if (!return_level_var?.variant) {
    console.warn("No shipping protection level found");
    return;
  }

  const correctVariantId = return_level_var.variant;
  const matchedItems = parsedState.items.filter(
    item => item.product_id == window.shippingProtectionProduct
  );

  for (const item of matchedItems) {
    if (item.id != correctVariantId) {
      await fetch('/cart/change.js', {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });
    }
  }

  const isCorrectInCart = matchedItems.some(item => item.id == correctVariantId);
  if (!isCorrectInCart) {
    await fetch('/cart/add.js', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: correctVariantId, quantity: 1 })
    });
  }
}

async function removeShippingProtection_customjs() {
  try {
    const res = await fetch('/cart.js');
    const parsedState = await res.json();
    const matchedItems = parsedState.items.filter(
      item => item.product_id == window.shippingProtectionProduct
    );
    for (const item of matchedItems) {
      await fetch('/cart/change.js', {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });
    }
    await refreshSideCart_cartjs();
  } catch (e) {
    console.error("Error removing shipping protection:", e);
  }
}

// ========================
// FIX AUTO-ADD GIFTS
// ========================
async function fixGifts(parsedState) {
  const rows = document.querySelectorAll('tbody.gift-product-body tr[data-autoadd="true"]');
  if (!rows.length) return;

  const cartTotalCustom = parsedState.original_total_price / 100;
  const itemsToAdd = [];
  const itemsToRemove = [];

  rows.forEach(tr => {
    const autoProdId = parseInt(tr.getAttribute("data-prodid"));
    const autoProdThreshold = parseInt(tr.getAttribute("data-threeshhold"));
    if (!autoProdId || !autoProdThreshold) return;

    const freeProductInCart = parsedState.items.find(item => item.id === autoProdId);

    if (cartTotalCustom >= autoProdThreshold) {
      if (!freeProductInCart) {
        itemsToAdd.push({ id: autoProdId, quantity: 1 });
      } else if (freeProductInCart.quantity > 1) {
        itemsToRemove.push({ key: freeProductInCart.key, qty: 1 });
      }
    } else {
      if (freeProductInCart) {
        itemsToRemove.push({ key: freeProductInCart.key, qty: 0 });
      }
    }
  });

  if (itemsToAdd.length) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: itemsToAdd })
    });
  }

  for (const item of itemsToRemove) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: item.qty })
    });
  }
}

// Legacy wrappers kept for any calls that still use old function names
function autoCheckGiftInCart() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(parsedState => fixGifts(parsedState))
    .catch(err => console.error('Error fetching cart:', err));
}

function addToCart(items) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  }).then(() => refreshSideCart_cartjs());
}

function updateFromCart(itemKey, qty) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: itemKey, quantity: qty })
  }).then(() => refreshSideCart_cartjs());
}

function removeMultipleItems(keys = []) {
  if (!keys.length) return;
  const updates = {};
  keys.forEach(key => updates[key] = 0);
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates })
  })
    .then(res => res.json())
    .then(() => refreshSideCart_cartjs())
    .catch(err => console.error('Multi-remove failed:', err));
}

// ========================
// RELATED PRODUCT VARIANT PRICE UPDATE
// ========================
document.addEventListener("DOMContentLoaded", function () {
  function formatMoney(cents) {
    if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.shopCurrencyFormat || "${{amount}}");
    }
    return (cents / 100).toFixed(2);
  }

  document.addEventListener("change", function (e) {
    if (!e.target.classList.contains("rp-variant-select")) return;
    const wrapper = e.target.closest(".related-product");
    const priceDiv = wrapper?.querySelector(".rp-price");
    if (priceDiv) {
      const selectedOption = e.target.options[e.target.selectedIndex];
      priceDiv.textContent = formatMoney(selectedOption.dataset.price);
    }
  });

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".rp-add-btn");
    if (!btn) return;
    const wrapper = btn.closest(".related-product");
    const select = wrapper.querySelector(".rp-variant-select");
    const variantId = select ? select.value : null;
    if (!variantId) return;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(res => res.json())
      .then(() => updateCartAndRefresh())
      .catch(err => console.error("Add to cart error:", err));
  });
});

// ========================
// HOVER ADD TO CART (collection grid)
// ========================
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".variant-add-to-cart-on-hover-outer").forEach(wrapper => {
    const variantList = wrapper.querySelector(".on-hover-variant-list");
    const addToCartBtn = wrapper.querySelector(".add-to-cart-btn");
    if (!variantList || !addToCartBtn) return;

    const variantItems = variantList.querySelectorAll(".variant-item");

    variantItems.forEach(item => {
      item.addEventListener("click", () => {
        variantItems.forEach(i => i.classList.remove("selected"));
        item.classList.add("selected");
        item.insertAdjacentHTML("beforeend", `
          <div class="variant-add-cart-on-hover-loading__spinner">
            <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
              <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
            </svg>
          </div>`
        );
        addToCartBtn.setAttribute("data-addcart", item.dataset.variantId);
        addToCartBtn.click();
      });
    });

    addToCartBtn.addEventListener("click", () => {
      const selectedVariantId = addToCartBtn.getAttribute("data-addcart");
      if (!selectedVariantId) { alert("Please select a variant first."); return; }

      const spinner = addToCartBtn.querySelector(".variant-add-cart-on-hover-loading__spinner");
      if (spinner) spinner.classList.remove("hidden");

      fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: selectedVariantId, quantity: 1 })
    })
      .then(res => res.json())
      .then(() => {
        if (spinner) spinner.classList.add("hidden");
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.classList.add('active');
          cartDrawer.classList.remove('is-empty');
          const emptyEl = cartDrawer.querySelector('.drawer__inner-empty');
          if (emptyEl) emptyEl.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:200px;"><svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66" width="40" height="40"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path" stroke="currentColor"></circle></svg></div>';
        }
        const spinnerEl = addToCartBtn.closest(".variant-add-to-cart-on-hover-outer")
          ?.querySelector(".variant-add-cart-on-hover-loading__spinner");
        if (spinnerEl) spinnerEl.remove();
        updateCartAndRefresh();
      })
        .catch(err => {
          console.error("Add to cart failed:", err);
          if (spinner) spinner.classList.add("hidden");
          const spinnerEl = addToCartBtn.closest(".variant-add-to-cart-on-hover-outer")
            ?.querySelector(".variant-add-cart-on-hover-loading__spinner");
          if (spinnerEl) spinnerEl.remove();
        });
    });
  });
});

// ========================
// STICKY ADD TO CART (product page)
// ========================
document.addEventListener("DOMContentLoaded", () => {
  function handleStickyButtons() {
    const productButtons = document.querySelector(".default_product_page .product-form__buttons");
    if (!productButtons) return;
    const scrollY = window.scrollY || window.pageYOffset;
    if (scrollY <= 0) {
      document.body.classList.remove("stick-btn");
      productButtons.classList.remove("stick");
    } else {
      document.body.classList.add("stick-btn");
      productButtons.classList.add("stick");
    }
  }
  handleStickyButtons();
  window.addEventListener("scroll", handleStickyButtons, { passive: true });
});

// ========================
// FIND SIZE POPUP
// ========================
const trigger = document.querySelector(".find-fit");
const popup = document.querySelector(".product_find_size");

if (popup) {
  const closeBtn = popup.querySelector(".close");
  const overlay = popup.querySelector(".find-size-overlay");

  if (trigger) {
    trigger.addEventListener("click", () => {
      popup.classList.remove("hidden");
      document.body.classList.add("no-scroll");
    });
  }

  const closePopup = () => {
    popup.classList.add("hidden");
    document.body.classList.remove("no-scroll");
  };

  if (closeBtn) closeBtn.addEventListener("click", closePopup);
  if (overlay) overlay.addEventListener("click", closePopup);
}

setTimeout(() => {
  if (typeof window.initFindSize === "function") window.initFindSize();
}, 100);

// ========================
// COMPLETE THE LOOK — add to cart
// ========================
function bindCompleteTheSetButtons() {
  document.querySelectorAll('.complete_set_btn').forEach(function(btn) {
    btn.removeEventListener('click', handleCompleteSetClick);
    btn.addEventListener('click', handleCompleteSetClick);
  });
}

function handleCompleteSetClick(e) {
  e.stopPropagation();
  const btn = this;
  const card = btn.closest('.cts-card');
  if (!card) return;

  const selectEl = card.querySelector('.cts-card__size-select');
  const singleVariant = card.querySelector('.cts-single-variant');
  const variantId = selectEl ? selectEl.value : singleVariant ? singleVariant.value : null;

  if (!variantId) {
    if (selectEl) {
      selectEl.style.borderColor = 'red';
      setTimeout(() => selectEl.style.borderColor = '', 800);
    }
    return;
  }

  btn.textContent = 'ADDING...';
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
  })
    .then(res => res.json())
    .then(() => updateCartAndRefresh())
    .catch(err => {
      console.error('Add to cart error:', err);
      btn.textContent = 'ADD';
      btn.disabled = false;
    });
}

document.addEventListener('DOMContentLoaded', bindCompleteTheSetButtons);

const ctsObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(node) {
      if (node.nodeType !== 1) return;
      if (node.tagName === 'CART-DRAWER' || (node.querySelector && node.querySelector('.complete_set_btn'))) {
        setTimeout(bindCompleteTheSetButtons, 100);
      }
    });
  });
});

ctsObserver.observe(document.body, { childList: true, subtree: true });

// ========================
// DISCOUNT YARD TAG LAYOUT FIX
// ========================
function fixDiscountYardTags() {
  const wrapper = document.querySelector('.stack-discounts-tags-wrapper');
  if (wrapper) {
    wrapper.style.setProperty('display', 'flex', 'important');
    wrapper.style.setProperty('flex-direction', 'row', 'important');
    wrapper.style.setProperty('flex-wrap', 'wrap', 'important');
    wrapper.style.setProperty('gap', '6px', 'important');
  }
  document.querySelectorAll('.stack-discounts-tag').forEach(tag => {
    tag.style.setProperty('display', 'inline-flex', 'important');
    tag.style.setProperty('width', 'auto', 'important');
    tag.style.setProperty('flex', '0 0 auto', 'important');
    tag.style.setProperty('white-space', 'nowrap', 'important');
  });
}

document.addEventListener('DOMContentLoaded', fixDiscountYardTags);
setTimeout(fixDiscountYardTags, 1000);
setTimeout(fixDiscountYardTags, 2000);

const dyTagObserver = new MutationObserver(function() {
  fixDiscountYardTags();
});
dyTagObserver.observe(document.body, { childList: true, subtree: true });

// ========================
// STACKDISCOUNTS REINIT ON CART UPDATE
// ========================
document.addEventListener('cart:updated', function() {
  if (!window.StackDiscounts) return;
  [100, 400, 900, 1800].forEach(function(delay) {
    setTimeout(function() {
      if (window.StackDiscounts) {
        window.StackDiscounts.initStackDiscounts();
        window.StackDiscounts.initProductBundles();
        window.StackDiscounts.initProductLabels();
      }
    }, delay);
  });
});